import React from "react";
import { Form, Col } from "react-bootstrap";

const DocumentUploader = ({ file, onFileChange, processing, agentType }) => {
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      const validTypes = agentType === 'hiro' 
        ? ["application/pdf", "image/jpeg", "image/png"] 
        : ["application/pdf"];
        
      if (validTypes.includes(selectedFile.type)) {
        onFileChange(selectedFile);
      } else {
        alert(agentType === 'hiro' ? "El archivo debe ser PDF, JPG o PNG" : "El archivo debe ser un PDF");
      }
    }
  };

  const getFileTypeDescription = () => {
    switch (agentType) {
      case 'lexi': return "RIT, RISS, contratos, manuales";
      case 'hiro': return "Documentos PDF o Imágenes (JPG/PNG)";
      case 'vexa': return "Cotizaciones, manuales de productos";
      default: return "documentos PDF";
    }
  };

  return (
    <Col md={6}>
      <Form.Group className="mb-3">
        <Form.Label>{agentType === 'hiro' ? "Seleccionar Documento o Imagen" : "Seleccionar Documento PDF"}</Form.Label>
        <Form.Control
          type="file"
          accept={agentType === 'hiro' ? "application/pdf,image/jpeg,image/png" : "application/pdf"}
          onChange={handleFileChange}
          disabled={processing}
        />
        <Form.Text className="text-muted">
          Selecciona un archivo ({getFileTypeDescription()})
        </Form.Text>
      </Form.Group>
    </Col>
  );
};

export default DocumentUploader;